import { ClipboardIcon, PlusCircleIcon } from "@heroicons/react/24/outline"

// import { useLoaderData } from "react-router-dom"

import { DashboardContent } from "../Dashboard/DashboardContent"
import { Bee } from "~/src/components/BeeKit"
import { MainHeading } from "~/src/components/MainHeading"

//region Types
export type DashboardGiftCardsIndexProps = {
  store: {
    id: number
    name: string
  }
  giftCards: {
    id: number
    user_id: number
    user_name: string
    original_value: number
    current_value: number
    code: string
  }[]
}
//endregion

//region Component
export function DashboardGiftCardsIndex() {
  // const { store, giftCards } = useLoaderData() as DashboardGiftCardsIndexProps

  return (
    <DashboardContent className="@container flex flex-col gap-4">
      <MainHeading
        title="Gift Cards"
        className="mr-auto ml-0"
        actions={
          <>
            <Bee.ButtonAnchor
              href=""
              kind="secondary"
              className="border-grey-200 text-grey-900 flex h-10 items-center justify-center gap-2 rounded border bg-white px-4 py-2 text-sm font-normal"
            >
              <ClipboardIcon className="h-6 w-6" />
              <span>Generate report</span>
            </Bee.ButtonAnchor>

            <Bee.ButtonAnchor
              href=""
              className="flex h-10 w-auto items-center justify-center gap-2.5 rounded border-2 px-4 py-2 text-sm font-normal"
            >
              <PlusCircleIcon className="h-6 w-6" />
              <span>Create gift card</span>
            </Bee.ButtonAnchor>
          </>
        }
      />
    </DashboardContent>
  )
}
//endregion
